<h2 mat-dialog-title>{{ 'AI_ASSISTANT.FUNCTIONS.ADD_FUNCTION.ADD_A_FUNCTION' | translate }}</h2>
<mat-dialog-content class="tool-dialog-content">
  <ai-tools-table
    [assistantType]="assistantType"
    [excludedFunctionIds]="excludedFunctionIds"
    (selectedFunctions)="setTableSelectedFunctions($event)"
    class="tools-table"
  >
  </ai-tools-table>
</mat-dialog-content>
<mat-dialog-actions align="start" class="actions">
  <button mat-button type="button" color="primary" (click)="newFunction()">
    <mat-icon>add</mat-icon>
    {{ 'AI_ASSISTANT.FUNCTIONS.ADD_FUNCTION.NEW_FUNCTION' | translate }}
  </button>

  <span class="spacer"></span>

  <button mat-stroked-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="tableSelectedFunctions().length === 0"
    (click)="chooseFunctions(tableSelectedFunctions())"
  >
    {{ 'AI_ASSISTANT.SHARED.ADD' | translate }}
  </button>
</mat-dialog-actions>
